<template>
  <section id="about" class="overflow-hidden bg-black py-24 sm:py-32" aria-labelledby="about-heading" data-section-name="About">
    <div class="mx-auto max-w-7xl px-6 lg:px-8">
      <div class="mx-auto grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 sm:gap-y-20 lg:mx-0 lg:max-w-none lg:grid-cols-2">
        <article class="lg:pr-8 lg:pt-4">
          <div class="lg:max-w-lg">
            <p class="text-base font-semibold leading-7 text-gray-400">Lightning Fast</p>
            <h2 id="about-heading" class="mt-2 text-3xl font-bold tracking-tight text-white sm:text-4xl">Built for developers, by developers</h2>
            <p class="mt-6 text-lg leading-8 text-gray-300">PDFGen streamlines your document generation workflow with a simple, powerful API that handles the complexity of PDF creation so you don't have to.</p>
            <dl class="mt-10 max-w-xl space-y-8 text-base leading-7 text-gray-300 lg:max-w-none">
              <div v-for="feature in features" :key="feature.name" class="relative pl-9">
                <dt class="inline font-semibold text-white">
                  <component :is="feature.icon" class="absolute left-1 top-1 h-5 w-5 text-white" aria-hidden="true" />
                  {{ feature.name }}
                </dt>
                <dd class="inline"> {{ feature.description }}</dd>
              </div>
            </dl>
          </div>
        </article>
        <img src="https://images.unsplash.com/photo-1498758536662-35b82cd15e29?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2102&q=80" alt="PDFGen API dashboard showing real-time PDF conversion tracking and developer-friendly interface" class="w-[48rem] max-w-none rounded-xl shadow-xl ring-1 ring-gray-600 sm:w-[57rem] md:-ml-4 lg:-ml-0" width="2432" height="1442" loading="lazy">
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { h } from 'vue'

const features = [
  {
    name: 'Simple Integration.',
    description: 'Get started with a single API call. Our RESTful API is designed for quick integration into any tech stack.',
    icon: () => h('svg', { fill: 'currentColor', viewBox: '0 0 20 20' }, [
      h('path', { 'fill-rule': 'evenodd', d: 'M3 4a1 1 0 011-1h12a1 1 0 011 1v2a1 1 0 01-1 1H4a1 1 0 01-1-1V4zm0 4a1 1 0 011-1h12a1 1 0 011 1v2a1 1 0 01-1 1H4a1 1 0 01-1-1V8zm0 4a1 1 0 011-1h12a1 1 0 011 1v2a1 1 0 01-1 1H4a1 1 0 01-1-1v-2z', 'clip-rule': 'evenodd' })
    ])
  },
  {
    name: 'Scale with Confidence.',
    description: 'Built to handle thousands of PDF generation requests with consistent performance and reliability.',
    icon: () => h('svg', { fill: 'currentColor', viewBox: '0 0 20 20' }, [
      h('path', { 'fill-rule': 'evenodd', d: 'M3 3a1 1 0 000 2v8a2 2 0 002 2h2.586l-1.293 1.293a1 1 0 101.414 1.414L10 15.414l2.293 2.293a1 1 0 001.414-1.414L12.414 15H15a2 2 0 002-2V5a1 1 0 100-2H3zm11.707 4.707a1 1 0 00-1.414-1.414L10 9.586 8.707 8.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z', 'clip-rule': 'evenodd' })
    ])
  },
  {
    name: 'Multiple Use Cases.',
    description: 'Perfect for invoices, reports, contracts, receipts, certificates, and any document generation need.',
    icon: () => h('svg', { fill: 'currentColor', viewBox: '0 0 20 20' }, [
      h('path', { 'fill-rule': 'evenodd', d: 'M4 2a2 2 0 00-2 2v11a3 3 0 106 0V4a2 2 0 00-2-2H4zm1 14a1 1 0 100-2 1 1 0 000 2zm5-1.757l4.9-4.9a2 2 0 000-2.828L13.485 5.1a2 2 0 00-2.828 0L10 5.757v8.486zM16 18H9.071l6-6H16a2 2 0 012 2v2a2 2 0 01-2 2z', 'clip-rule': 'evenodd' })
    ])
  },
]
</script>
